"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Svg = require("../Svg");
var _fonts = require("../fonts");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var exclamationPoint = function exclamationPoint(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9 13H11V15H9V13ZM9 5H11V11H9V5Z",
    fill: "#41C6A7"
  }));
};
exclamationPoint.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var Svg = (0, _styledComponents.default)(_Svg.Svg)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  min-width: 20px;\n  margin-right: 8px;\n"])));
var Alert = function Alert(_ref2) {
  var children = _ref2.children,
    iconColor = _ref2.iconColor,
    _ref2$component = _ref2.component,
    Component = _ref2$component === void 0 ? _fonts.Small : _ref2$component,
    className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Svg, {
    as: exclamationPoint,
    color: iconColor !== null && iconColor !== void 0 ? iconColor : 'tertiaryShade'
  }), /*#__PURE__*/_react.default.createElement(Component, null, children));
};
exports.Alert = Alert;